import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { Edge, EdgeChange } from '@xyflow/react';

export function FN_GRAPH_UPDATE__edge_add__by_change(change: EdgeChange<Edge>, graph: DTO_GRAPH__instance) {
  if (change.type !== 'add') return false;

  return true;
}
